import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const star: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13-6.953q-.002.175-.203.375L9.969-3.812 10.64.109v.157a.46.46 0 0 1-.078.265.27.27 0 0 1-.235.125.6.6 0 0 1-.312-.093L6.5-1.297 3 .563a.7.7 0 0 1-.312.093q-.176-.001-.25-.125a.44.44 0 0 1-.079-.265q-.001-.05.016-.157l.672-3.921L.203-6.578Q0-6.778 0-6.953c0-.188.145-.305.438-.36l3.921-.562 1.766-3.562q.141-.312.375-.313.233.001.39.313l1.75 3.562 3.923.563c.289.054.437.171.437.359m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11.75)"
    />
  ),
  svgProps: {
    height: "12.406",
    width: "13",
  }
};
